import { vuexEventPathGenerator } from '@/utils';
export const mutationType = {
    SET_IS_HQ: 'SET_IS_HQ',
    SET_IS_OPEN_CONFIG_DIALOG: 'SET_IS_OPEN_CONFIG_DIALOG',
    SET_SELECTED_ITEM_KEY: 'SET_SELECTED_ITEM_KEY',
    SET_WORKER_LIST: 'SET_WORKER_LIST',
    SET_SELECTED_WORKER: 'SET_SELECTED_WORKER',
    SET_WORKER_FILTER: 'SET_WORKER_FILTER',
    ON_OFF_WORKER: 'ON_OFF_WORKER',
    UPDATE_WORKER: 'UPDATE_WORKER',
    ADD_WORKER: 'ADD_WORKER',
    CHECK_RELATED_WORKER: 'CHECK_RELATED_WORKER',
    ADD_RELATED_WORKER_LIST: 'ADD_RELATED_WORKER_LIST',
    CLEAR_RELATED_WORKER_LIST: 'CLEAR_RELATED_WORKER_LIST',
    SET_WORKER_TOTAL_COUNT: 'SET_WORKER_TOTAL_COUNT',
    UPDATE_STATUS_WORKER: 'UPDATE_STATUS_WORKER',
    DELETE_WORKER: 'DELETE_WORKER',
    DELETE_ALL_WORKER: 'DELETE_ALL_WORKER',
    INPUT_SEARCH_WORKER_QUERY: 'INPUT_SEARCH_WORKER_QUERY',
    SET_IS_HIDE_SHARE_WORKER: 'SET_IS_HIDE_SHARE_WORKER',
    SET_IS_HIDE_WORKER_MARKER: 'SET_IS_HIDE_WORKER_MARKER',
    SET_ORDER_LIST: 'SET_ORDER_LIST',
    SET_STORE_LIST: 'SET_STORE_LIST',
    ADD_SELECTED_ORDER_ITEM_BY_ID: 'ADD_SELECTED_ORDER_ITEM_BY_ID',
    CLEAR_SELECTED_ORDER_ITEM_BY_ID: 'CLEAR_SELECTED_ORDER_ITEM_BY_ID',
    SET_MAP_HOVERED_ORDER_ID: 'SET_MAP_HOVERED_ORDER_ID',
    SET_SELECTED_BY_SNACKBAR: 'SET_SELECTED_BY_SNACKBAR',
    SET_ORDER_FILTER: 'SET_ORDER_FILTER',
    SET_SELECTED_STORE_ORDER_LIST: 'SET_SELECTED_STORE_ORDER_LIST',
    SET_STATUS_TOTAL_COUNT: 'SET_STATUS_TOTAL_COUNT',
    UPDATE_STATUS_ORDER: 'UPDATE_STATUS_ORDER',
    UPDATE_ORDER_CARD_NAME: 'UPDATE_ORDER_CARD_NAME',
    UPDATE_ORDER_CARD_APPROVE_NUMBER: 'UPDATE_ORDER_CARD_APPROVE_NUMBER',
    UPDATE_ORDER: 'UPDATE_ORDER',
    DELETE_ORDER: 'DELETE_ORDER',
    INPUT_SEARCH_ORDER_QUERY: 'INPUT_SEARCH_ORDER_QUERY',
    SET_MODAL_ORDER_DATA: 'SET_MODAL_ORDER_DATA',
    SET_IS_HIDE_SHARE_ORDER: 'SET_IS_HIDE_SHARE_ORDER',
    ADD_STORE: 'ADD_STORE',
    DELETE_STORE: 'DELETE_STORE',
    SET_SELECTED_STORE_ID: 'SET_SELECTED_STORE_ID',
    CELAR_SELECTED_ORDER_ITEMS: 'CELAR_SELECTED_ORDER_ITEMS',
    SET_IS_HIDE_STORE_MARKER: 'SET_IS_HIDE_STORE_MARKER',
    SET_MODAL_WORKER_DATA: 'SET_MODAL_WORKER_DATA',
    CLEAR_MODAL_WORKER_DATA: 'CLEAR_MODAL_WORKER_DATA',
    DELAY_SHARE_ORDER: 'DELAY_SHARE_ORDER',
    ADD_ORDER: 'ADD_ORDER',
    SET_SELECTED_WORKER_ORDER_LIST: 'SET_SELECTED_WORKER_ORDER_LIST',
    DELETE_SELECTED_WORKER_ORDER_LIST: 'DELETE_SELECTED_WORKER_ORDER_LIST',
    CLEAR_SELECTED_WORKER_ORDER_LIST: 'CLEAR_SELECTED_WORKER_ORDER_LIST',
};
export const mapControlMutationType = vuexEventPathGenerator(mutationType, 'mapControl');
// 기본
const baseDomain = {
    [mutationType.SET_IS_HQ](state, isHQ) {
        state.isHQ = isHQ;
    },
    [mutationType.SET_IS_OPEN_CONFIG_DIALOG](state, isOpen) {
        state.isOpenConfigDialog = isOpen;
    },
    [mutationType.SET_SELECTED_ITEM_KEY](state, payload) {
        state.selectedItemKey = payload;
    },
};
// 라이더 관련
const workerDomain = {
    [mutationType.CLEAR_MODAL_WORKER_DATA](state) {
        state.modalWorkerData = {};
    },
    [mutationType.SET_MODAL_WORKER_DATA](state, payload) {
        state.modalWorkerData = payload;
    },
    // 라이더 관련
    [mutationType.SET_WORKER_LIST](state, payload) {
        state.workerList = payload;
    },
    [mutationType.SET_SELECTED_WORKER](state, payload) {
        state.selectedWorker = payload;
    },
    [mutationType.SET_WORKER_FILTER](state, filterList) {
        state.selectedWorkerFilter = filterList;
    },
    [mutationType.ON_OFF_WORKER](state, { code, flag }) {
        if (!flag) {
            state.workerList[code].isTemporallyOff = true;
            return state.workerList[code].isTemporallyOff;
        }
        return delete state.workerList[code].isTemporallyOff;
    },
    [mutationType.UPDATE_WORKER](state, worker) {
        const { user: { code } } = worker;
        state.workerList[code] = worker;
    },
    [mutationType.ADD_WORKER](state, worker) {
        state.workerList[worker.user.code] = worker;
    },
    [mutationType.CHECK_RELATED_WORKER](state, code) {
        const oldValue = state.workerList[code].relatedWeight;
        const newValue = oldValue ? oldValue + 1 : 1;
        state.workerList[code].relatedWeight = newValue;
    },
    [mutationType.ADD_RELATED_WORKER_LIST](state, workerData) {
        const { user: { code } } = workerData;
        state.relatedWorkerList[code] = workerData;
    },
    /**
     * 연관 워커 제거
     * 워커 코드 없을 시 전체 제거
     * @param {*} state
     * @param {string} workerCode 워커 코드
     */
    [mutationType.CLEAR_RELATED_WORKER_LIST](state, workerCode = '') {
        if (!workerCode) {
            state.relatedWorkerList = {};
            return;
        }
        const workerData = state.workerList[workerCode];
        if (workerData && workerData.relatedWeight <= 0) {
            delete state.relatedWorkerList[workerCode];
        }
    },
    [mutationType.SET_WORKER_TOTAL_COUNT](state, payload) {
        const all = Object.keys(payload).reduce((count, key) => count + payload[key], 0);
        state.workerTotal = {
            ...payload,
            all,
        };
    },
    /**
     * 워커 통계 업데이트
     * @param {*} state
     * @param {Ojbect} updateData
     */
    [mutationType.UPDATE_STATUS_WORKER](state, updateData) {
        let count = 0;
        Object.keys(updateData).forEach((key) => {
            if (key !== 'null') {
                state.workerTotal[key] += updateData[key];
                count += updateData[key];
            }
        });
        state.workerTotal.all += count;
    },
    [mutationType.DELETE_WORKER](state, workerCode) {
        delete state.workerList[workerCode];
    },
    [mutationType.DELETE_ALL_WORKER](state) {
        state.workerList = {};
    },
    [mutationType.INPUT_SEARCH_WORKER_QUERY](state, query) {
        state.searchWorkerQuery = query;
    },
    [mutationType.SET_IS_HIDE_SHARE_WORKER](state, isHide) {
        state.mapVisibilitySetting.isHideShareWorker = isHide;
    },
    [mutationType.SET_IS_HIDE_WORKER_MARKER](state, isHide) {
        state.mapVisibilitySetting.isHideWorkerMarker = isHide;
    },
};
// 배달 요청 관련
const orderDomain = {
    [mutationType.DELAY_SHARE_ORDER]() {
        // Subscribe Mutation Only
    },
    [mutationType.ADD_ORDER](state, order) {
        state.orderList[order.orderId] = order;
    },
    [mutationType.SET_SELECTED_WORKER_ORDER_LIST](state, WorkerOrderList) {
        state.selectedWorkerOrderList = WorkerOrderList;
    },
    [mutationType.DELETE_SELECTED_WORKER_ORDER_LIST](state, orderId) {
        delete state.selectedWorkerOrderList[orderId];
    },
    [mutationType.CLEAR_SELECTED_WORKER_ORDER_LIST](state) {
        state.selectedWorkerOrderList = {};
    },
    [mutationType.SET_ORDER_LIST](state, payload = {}) {
        state.orderList = payload;
    },
    [mutationType.SET_STORE_LIST](state, payload) {
        state.storeList = payload;
    },
    [mutationType.ADD_SELECTED_ORDER_ITEM_BY_ID](state, orderData) {
        state.selectedOrderItemsObj[orderData.orderId] = orderData;
    },
    [mutationType.CLEAR_SELECTED_ORDER_ITEM_BY_ID](state, orderId) {
        delete state.selectedOrderItemsObj[orderId];
    },
    // 지도 배달동선
    [mutationType.SET_MAP_HOVERED_ORDER_ID](state, id = '') {
        state.mapHoveredOrderId = id;
    },
    // 배달 스낵바
    [mutationType.SET_SELECTED_BY_SNACKBAR](state, status = {}) {
        state.selectedBySnackbar = status;
    },
    /**
     * 현재 필터값 셋팅
     * @param {Object} state
     * @param {Array} filterList
     */
    [mutationType.SET_ORDER_FILTER](state, filterList) {
        state.selectedOrderFilter = filterList;
    },
    [mutationType.SET_SELECTED_STORE_ORDER_LIST](state, storeOrderList) {
        state.selectedStoreOrderList = storeOrderList;
    },
    /**
     * 주문 통계 최초 셋팅
     */
    [mutationType.SET_STATUS_TOTAL_COUNT](state, { ACCEPTED, ALLOCATED, PICKUP }) {
        const ALL = ACCEPTED + ALLOCATED + PICKUP;
        state.orderTotal = {
            ACCEPTED,
            ALLOCATED,
            PICKUP,
            ALL,
        };
    },
    /**
     * 주문 통계 업데이트
     * @param state
     * @param updateStatusCount 업데이트 될 상태별 카운트
     */
    [mutationType.UPDATE_STATUS_ORDER](state, updateStatusCount) {
        // 주문 카운트 통계
        const { orderTotal } = state;
        let all = 0;
        Object.keys(updateStatusCount).forEach((status) => {
            if (status !== 'null') {
                orderTotal[status] += updateStatusCount[status];
                if (orderTotal[status] < 0) {
                    orderTotal[status] = 0;
                }
                all += updateStatusCount[status];
            }
        });
        orderTotal.ALL += all;
    },
    [mutationType.UPDATE_ORDER_CARD_NAME](state, { orderId, cardName }) {
        const order = state.orderList[orderId];
        if (!order) {
            console.log(`[UPDATE_ORDER_CARD_NAME] Not Exist Order. Order Id ${orderId}`);
            return;
        }
        order.cardName = cardName;
    },
    [mutationType.UPDATE_ORDER_CARD_APPROVE_NUMBER](state, { orderId, cardApproveNumber }) {
        const order = state.orderList[orderId];
        if (!order) {
            console.log(`[UPDATE_ORDER_CARD_APPROVE_NUMBER] Not Exist Order. Order Id ${orderId}`);
            return;
        }
        order.cardApproveNumber = cardApproveNumber;
    },
    [mutationType.UPDATE_ORDER](state, order) {
        const { orderId } = order;
        const updatedOrder = Object.assign(state.orderList[orderId], order);
        state.orderList[orderId] = updatedOrder;
    },
    [mutationType.DELETE_ORDER](state, orderId) {
        delete state.orderList[orderId];
    },
    [mutationType.INPUT_SEARCH_ORDER_QUERY](state, query) {
        state.searchOrderQuery = query;
    },
    [mutationType.SET_MODAL_ORDER_DATA](state, orderData) {
        state.modalOrderData = orderData;
    },
    [mutationType.SET_IS_HIDE_SHARE_ORDER](state, isHide) {
        state.mapVisibilitySetting.isHideShareOrder = isHide;
    },
};
// 상점 관련
const storeDomain = {
    [mutationType.ADD_STORE](state, store) {
        state.storeList[store.storeId] = store;
    },
    [mutationType.DELETE_STORE](state, storeId) {
        delete state.storeList[storeId];
    },
    // 선택한 상점
    [mutationType.SET_SELECTED_STORE_ID](state, storeId) {
        state.selectedStoreId = storeId;
    },
    // 선택한 상점 일괄 취소
    [mutationType.CELAR_SELECTED_ORDER_ITEMS](state) {
        state.selectedOrderItemsObj = {};
    },
    [mutationType.SET_IS_HIDE_STORE_MARKER](state, isHide) {
        state.mapVisibilitySetting.isHideStoreMarker = isHide;
    },
};
const mutations = {
    ...baseDomain,
    ...workerDomain,
    ...orderDomain,
    ...storeDomain,
};
export default mutations;
